
import { PropType } from 'vue';
import { mapActions, mapGetters } from 'vuex';
import { EventBus } from '@/functions/eventBus';
import oBrokerSearchList from '@/components/organisms/brokerSearch/BrokerSearchList.vue';
import oBrokerSearchMap from '@/components/organisms/brokerSearch/BrokerSearchMap.vue';
import Query, { Param } from '@/functions/query';
import { QueryNames } from '@/enums/querynames.enum';
import Broker from '@/interfaces/broker.interface';
import oBrokerAreaCard from '@/components/organisms/broker/BrokerAreaCard.vue';

interface Texts {
    searchList: {
        heading: string;
        noResultsHeading: string;
        resetButtonText: string;
        brokerAreaCardsHeadline: string;
    };
    searchMap: {
        viewMap: string;
        closeMap: string;
        viewList: string;
    };
}

interface Data {
    isDesktop: boolean;
}

export default {
    name: 't-broker-search',
    components: {
        oBrokerSearchList,
        oBrokerSearchMap,
        oBrokerAreaCard,
    },

    props: {
        texts: {
            type: Object as PropType<Texts>,
            default: () => ({
                searchList: {
                    heading: '',
                    noResultsHeading: '',
                    resetButtonText: '',
                    brokerAreaCardsHeadline: '',
                },
                searchMap: {
                    viewMap: '',
                    closeMap: '',
                    viewList: '',
                },
            }),
        },
        brokerAreaCards: {
            type: Array as PropType<Broker[]>,
            default: () => [],
        },
    },

    data(): Data {
        return {
            isDesktop: EventBus.isDesktop,
        };
    },

    computed: {
        ...mapGetters({
            view: 'brokerSearch/view',
            brokers: 'brokerSearch/results',
        }),
        viewTogglerText(): string {
            if (this.view === 'list') {
                return this.texts.searchMap.viewMap;
            }

            return this.isDesktop ? this.texts.searchMap.closeMap : this.texts.searchMap.viewList;
        },
    },

    beforeMount(): void {
        EventBus.$on('app.resize', () => {
            this.isDesktop = EventBus.isDesktop;
        });

        this.loadSearch();

        if (this.view === '') {
            if (this.isDesktop) {
                this.setView('map');
            } else {
                this.setView('list');
            }
        }
    },

    mounted(): void {
        document.querySelector('body')?.classList.add('isSearchPage');
    },

    beforeUnmount(): void {
        EventBus.$off('app.resize');
    },

    methods: {
        ...mapActions({
            setView: 'brokerSearch/setView',
            setQuery: 'brokerSearch/setQuery',
            toggleView: 'brokerSearch/toggleView',
            fetchResults: 'brokerSearch/fetchResults',
        }),

        loadSearch(): void {
            let params = Query.getAll();

            if (!params.length) {
                this.fetchResults();

                return;
            }

            params.forEach((param: Param) => {
                if (
                    typeof param.value === 'string'
                    && param.key === QueryNames.query
                ) {
                    this.setQuery(param.value);
                }
            });
        },
    },
};
